/* eslint-disable */
import React from "react";
import { LogoutAction } from "../../redux/actions/user";
import { connect } from "react-redux";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <h4>Something went wrong.</h4>
          <a href="/">
            <button onClick={(e) => this.props.LogoutAction()}>
              BACK TO HOME
            </button>
          </a>
        </>
      );
    }

    return this.props.children;
  }
}

export default connect(null, { LogoutAction })(ErrorBoundary);
